import { useTranslation } from "react-i18next";
import { deepCopy, isEmptyList, sortByField } from "../../utils";
import { ReactComponent as Plus } from "../../assets/plus.svg";
import { ReactComponent as Trash } from "../../assets/trash.svg";

function TemplateOperationEvents(props) {
  const { t } = useTranslation();
  const {
    operation,
    isReadOnly,
    operationEventTypes,
    onOpenAddEventModal,
    onRemoveOperationEvent,
  } = props;

  const hasOperationEvents = !isEmptyList(operation?.events);
  const eventsToRender = hasOperationEvents ? deepCopy(operation.events) : [];
  sortByField(eventsToRender, "name");
  return (
    <div className="resource-fields template-operation-events">
      <div className="module-header">
        <div>
          <h3>{t("operation_events")}</h3>
        </div>
        <div>
          {!isReadOnly && !isEmptyList(operationEventTypes) && (
            <button className="alternate" onClick={onOpenAddEventModal}>
              <Plus /> {t("add_operation_event")}
            </button>
          )}
        </div>
      </div>
      {hasOperationEvents && (
        <div className="module-wide">
          <div className="operation-events-list">
            {eventsToRender &&
              eventsToRender.map((operationEvent) => (
                <div className="operation-event" key={operationEvent.uuid}>
                  <div>
                    <div className="operation-event-name">
                      {operationEvent.name}
                    </div>
                    <div>
                      <div className="button-icon circle">
                        {!isReadOnly && (
                          <Trash
                            onClick={() => {
                              onRemoveOperationEvent(operationEvent.eventType);
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
      {!hasOperationEvents && (
        <div className="module-wide">
          <div className="empty-state">{t("no_operation_events")}</div>
        </div>
      )}
    </div>
  );
}

export default TemplateOperationEvents;
